$(document).on('turbo:load', function() {
  $(document).on('change', '.companies-sales-funnel-component select[name=timeline]', function() {
    const timeline = $(this).val();
    const component = $(this).closest('.companies-sales-funnel-component');
    const hsCompanyId = component.attr('hs_company_id');
    $.get(`/components/companies/sales_funnel?timeline=${timeline}&hs_company_id=${hsCompanyId}`).done(function(html) {
      component.replaceWith(html);
    });
  });
});